import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select, Box } from "@material-ui/core";
import { useDockerManagementContext } from "../../DockerManagementProvider";

export default function DeviceModeFormField({ control, errors }) {
	const { state: { modes } } = useDockerManagementContext();
	return (
		<Box display="flex">
			<Box flexGrow={1}>
				<FormControl fullWidth>
					<InputLabel shrink={true}>Device Mode</InputLabel>
					<Controller
						name="mode"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								defaultValue=""
								placeholder="Select a device mode..."
								fullWidth
								notched={true}
								error={!!errors.mode}>
								{modes.map(s => {
									return <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
								})}
							</Select>
						)}
					/>
				</FormControl>
			</Box>
		</Box>
	);
}